import { render, staticRenderFns } from "./AutoawardFormV3.vue?vue&type=template&id=7d96ef0e&scoped=true&"
import script from "./AutoawardFormV3.vue?vue&type=script&lang=js&"
export * from "./AutoawardFormV3.vue?vue&type=script&lang=js&"
import style0 from "./AutoawardFormV3.vue?vue&type=style&index=0&id=7d96ef0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d96ef0e",
  null
  
)

export default component.exports